<template>
  <div>
    <v-dialog
      v-model="viewDeliveryInvoiceModal"
      persistent
      max-width="850px"
      content-class="delivery-invoice-view-dialog"
    >
      <v-card id="print-area">
        <v-card-text v-if="viewDeliveryInvoiceModal">
          <table style="width: 100%" id="head-table">
            <tr>
              <td style="width: 130px;" class="print-pl-20">
                <img
                  style="width: 110px; height: 100px"
                  id="header-img"
                  src="../../../assets/images/black_shipzone.png"
                  alt=""
                />
              </td>
              <td>
                <table id="company-info" style="width: 100%;" class="print-ml-0">
                  <tr class="header-table">
                    <td style="font-size: 14px; font-weight: bold;" class="print-pr-20">
                      {{ companyData.company_name }}
                    </td>
                  </tr>
                  <tr class="header-table">
                    <td style="font-size: 14px" class="print-pr-20">
                      {{ companyData.company_address }}
                    </td>
                  </tr>
                  <tr class="header-table">
                    <td style="font-size: 14px" class="print-pr-20">
                      {{ companyData.company_email }}
                    </td>
                  </tr>
                  <tr class="header-table">
                    <td style="font-size: 14px" class="print-pr-20">
                      {{ companyData.phone_number }}
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>

          <table style="width: 100%; margin-top: 10px;" id="print-table1">
            <tr>
              <td style="text-align: center; padding: 8px 0;">
                <strong style="font-size: 22px; text-transform: uppercase;">{{ $t('delivery.deliveryInvoiceTitle') }}</strong>
              </td>
            </tr>
          </table>

          <table style="width: 100%; margin-bottom: 10px; border: 1px solid #000;" id="print-table2">
            <tr>
              <td style="padding: 10px; width: 50%; vertical-align: top; border-right: 1px solid #000;">
                <p style="font-size: 14px; margin: 3px 0;">
                  <strong>{{ $t('columns.invoiceNumber') }}:</strong>
                  <span> {{ invoiceData.invoice_number }}</span>
                </p>
                <p style="font-size: 14px; margin: 3px 0;">
                  <strong>{{ $t('customer.invoiceDate') }}:</strong>
                  <span> {{ invoiceData.created_at | moment('YYYY-MM-DD hh:mm A') }}</span>
                </p>
                <p v-if="invoiceData.status_name" style="font-size: 14px; margin: 3px 0;">
                  <strong>{{ $t('columns.status') }}:</strong>
                  <span> {{ invoiceData.status_name }}</span>
                </p>
                <p v-if="invoiceData.note" style="font-size: 14px; margin: 3px 0;">
                  <strong>{{ $t('columns.note') }}:</strong>
                  <span style="background-color: #FFF9C4; padding: 2px 6px; border-radius: 3px; -webkit-print-color-adjust: exact; print-color-adjust: exact; color-adjust: exact;"> {{ invoiceData.note }}</span>
                </p>
                <p v-if="resolvedCustomer.credit < 0" style="font-size: 14px; margin: 3px 0;">
                  <strong>{{ $t('delivery.customerBalanceLabel') }}</strong>
                  <span style="color: #c0392b; font-weight: bold;"> {{ resolvedCustomer.credit }} USD</span>
                </p>
              </td>
              <td style="padding: 10px; width: 50%; vertical-align: top;">
                <p style="font-size: 14px; font-weight: bold; margin: 0 0 6px 0; text-decoration: underline;">{{ $t('delivery.invoicedToLabel') }}</p>
                <p style="font-size: 14px; margin: 3px 0; font-weight: bold; background-color: yellow; color: black; display: inline-block; -webkit-print-color-adjust: exact; print-color-adjust: exact; color-adjust: exact;">
                  {{ resolvedCustomer.full_name }}
                </p>
                <p v-if="deliveryMethod === 'pickup'" style="font-size: 14px; margin: 3px 0;">
                  <strong>{{ $t('delivery.deliveryMethodLabel') }}</strong>
                  <span style="color: #e65100; font-weight: bold;">{{ $t('delivery.pickupInOfficeLabel') }}</span>
                </p>
                <p v-else-if="deliveryMethod === 'home' && deliveryAddressText" style="font-size: 14px; margin: 3px 0;">
                  <strong>{{ $t('columns.deliveryAddress') }}:</strong> {{ deliveryAddressText }}
                </p>
                <p v-else-if="defaultLocationText || resolvedCustomer.address" style="font-size: 14px; margin: 3px 0;">
                  <strong>{{ $t('columns.address') }}:</strong> {{ defaultLocationText || resolvedCustomer.address }}
                </p>
                <p style="font-size: 14px; margin: 3px 0;">
                  {{ $t('columns.phone') }}: {{ resolvedCustomer.phone_number }}
                </p>
                <p v-if="resolvedCustomer.phone_number_2" style="font-size: 14px; margin: 3px 0;">
                  {{ $t('delivery.phone2Label') }}: {{ resolvedCustomer.phone_number_2 }}
                </p>
              </td>
            </tr>
          </table>

          <div
            v-if="invoicesList.length"
            class="print-scroll-x"
          >
          <table
            style="width: 100%; min-width: 650px; border-collapse: collapse; border: 1px solid #000;"
          >
            <thead>
              <tr style="background-color: #f2f2f2; font-size: 13px;">
                <th style="border: 1px solid #000; padding: 6px; text-align: center;">#</th>
                <th style="border: 1px solid #000; padding: 6px;">{{ $t('columns.invoiceNo') }}</th>
                <th style="border: 1px solid #000; padding: 6px; text-align: center;">{{ $t('invoice.ordersLabel') }}</th>
                <th style="border: 1px solid #000; padding: 6px; text-align: center;">{{ $t('reports.paymentStatus') }}</th>
                <th style="border: 1px solid #000; padding: 6px; text-align: right;">{{ $t('columns.totalPrice') }}</th>
                <th style="border: 1px solid #000; padding: 6px; text-align: right;">{{ $t('reports.paid') }}</th>
                <th style="border: 1px solid #000; padding: 6px; text-align: right;">{{ $t('columns.remaining') }}</th>
                <th
                  v-if="canDetach"
                  class="no-print"
                  style="border: 1px solid #000; padding: 6px; text-align: center;"
                >{{ $t('columns.actions') }}</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(invoice, index) in invoicesList">
                <tr :key="'summary-' + invoice.invoice_number" style="font-size: 13px;">
                  <td style="border: 1px solid #000; padding: 5px; text-align: center;">{{ index + 1 }}</td>
                  <td style="border: 1px solid #000; padding: 5px;">{{ invoice.invoice_number }}</td>
                  <td style="border: 1px solid #000; padding: 5px; text-align: center;">{{ (invoice.orders || []).length }}</td>
                  <td style="border: 1px solid #000; padding: 5px; text-align: center;">
                    <span
                      :style="{ backgroundColor: paymentStatusColor(invoice.payment_status, invoice.edit_count).bg, color: paymentStatusColor(invoice.payment_status, invoice.edit_count).color, padding: '2px 8px', borderRadius: '12px', fontSize: '12px', fontWeight: 'bold', display: 'inline-block' }"
                    >{{ paymentStatusLabel(invoice.payment_status) }}</span>
                  </td>
                  <td style="border: 1px solid #000; padding: 5px; text-align: right;">$ {{ Number(invoice.total_price || 0).toFixed(2) }}</td>
                  <td style="border: 1px solid #000; padding: 5px; text-align: right;">$ {{ Number(invoice.paid_amount || 0).toFixed(2) }}</td>
                  <td style="border: 1px solid #000; padding: 5px; text-align: right;">$ {{ Number(invoice.remaining_amount || 0).toFixed(2) }}</td>
                  <td
                    v-if="canDetach"
                    class="no-print"
                    style="border: 1px solid #000; padding: 5px; text-align: center;"
                  >
                    <a
                      v-if="invoice.order_invoice_id"
                      :tooltip="$t('delivery.detachTooltip')"
                      style="color:#c62828; cursor:pointer;"
                      @click="detachInvoice(invoice)"
                    >
                      <i class="fa fa-unlink" />
                    </a>
                  </td>
                </tr>
                <tr :key="'detail-' + invoice.invoice_number" style="font-size: 12px;">
                  <td
                    :colspan="canDetach ? 8 : 7"
                    style="border: 1px solid #000; padding: 6px; background-color: #fafafa;"
                  >
                    <div class="print-scroll-x">
                    <table style="width: 100%; min-width: 480px; border-collapse: collapse;">
                      <thead>
                        <tr style="color: #616161;">
                          <th style="padding: 3px 5px; border-bottom: 1px solid #ccc;" class="text-align-left">{{ $t('delivery.orderNumberColumn') }}</th>
                          <th style="padding: 3px 5px; border-bottom: 1px solid #ccc;" class="text-align-left">{{ $t('columns.productName') }}</th>
                          <th style="padding: 3px 5px; text-align: center; border-bottom: 1px solid #ccc;">{{ $t('columns.size') }}</th>
                          <th style="padding: 3px 5px; text-align: right; border-bottom: 1px solid #ccc;">{{ $t('columns.price') }}</th>
                          <th style="padding: 3px 5px; text-align: center; border-bottom: 1px solid #ccc;">{{ $t('columns.qty') }}</th>
                          <th style="padding: 3px 5px; text-align: right; border-bottom: 1px solid #ccc;">{{ $t('columns.total') }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="order in invoice.orders" :key="order.order_id">
                          <td style="padding: 3px 5px;">{{ order.theOrderID }}</td>
                          <td style="padding: 3px 5px;">{{ order.product_name }}</td>
                          <td style="padding: 3px 5px; text-align: center;">{{ order.size }}</td>
                          <td style="padding: 3px 5px; text-align: right;">$ {{ orderUnitPriceCombined(order).toFixed(2) }}</td>
                          <td style="padding: 3px 5px; text-align: center;">{{ order.quantity }}</td>
                          <td style="padding: 3px 5px; text-align: right;">$ {{ orderLineTotalCombined(order).toFixed(2) }}</td>
                        </tr>
                      </tbody>
                    </table>
                    </div>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
          </div>

          <table style="width: 100%; border-collapse: collapse; margin-top: 10px; table-layout: fixed;">
            <colgroup>
              <col style="width: 160px;" />
              <col />
            </colgroup>
            <tr v-if="invoicesList.length" style="font-size: 15px; font-weight: bold;">
              <td style="border: 1px solid #000; padding: 6px 8px;">{{ $t('delivery.totalUsdLabel') }}</td>
              <td style="border: 1px solid #000; padding: 6px 8px; text-align: right;"><span style="background-color: yellow; color: black; -webkit-print-color-adjust: exact; print-color-adjust: exact; color-adjust: exact;">$ {{ totalUsd }}</span></td>
            </tr>
            <tr v-if="invoicesList.length" style="font-size: 15px; font-weight: bold;">
              <td style="border: 1px solid #000; padding: 6px 8px;">{{ $t('delivery.iraqiDinarLabel') }}</td>
              <td style="border: 1px solid #000; padding: 6px 8px; text-align: right;">{{ totalIqd }} IQD</td>
            </tr>
            <tr style="font-size: 15px; font-weight: bold;">
              <td style="border: 1px solid #000; padding: 6px 8px;">{{ $t('delivery.payOnDeliveryLabel') }}</td>
              <td style="border: 1px solid #000; padding: 6px 8px; text-align: right;">{{ formatIQD(invoiceData.pay_on_delivery_iqd) }} IQD</td>
            </tr>
            <tr style="font-size: 15px; font-weight: bold;">
              <td style="border: 1px solid #000; padding: 6px 8px;">{{ $t('delivery.totalIqdColonLabel') }}</td>
              <td style="border: 1px solid #000; padding: 6px 8px; text-align: right;"><span style="background-color: yellow; color: black; -webkit-print-color-adjust: exact; print-color-adjust: exact; color-adjust: exact;">{{ grandTotalIqd }} IQD</span></td>
            </tr>
          </table>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn id="close-button" style="height: auto" outline @click="$emit('close')"
            >{{ $t('common.cancel') }}</v-btn
          >
          <v-btn
            @click="printInvoice()"
            id="print-button"
            style="height: auto"
            outline
            color="primary"
            >{{ $t('printLogs.printButton') }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import swal from 'sweetalert'
import { roundUpIqd } from '../../mixins/helpers'

export default {
  props: ['viewDeliveryInvoiceModal', 'companyData', 'invoiceData'],

  data() {
    return {
      exRate: 1
    }
  },

  mounted() {
    const token = localStorage.getItem('access_token')
    axios
      .get('api/currency-rate/latest', { headers: { Authorization: 'Bearer ' + token } })
      .then((res) => {
        this.exRate = res.data ? res.data.ex_rate || 1 : 1
      })
      .catch(() => {})
  },

  computed: {
    // This modal is fed by two different shapes: DeliveryInvoiceController::show() (used by
    // branchDeliveredOrder.vue for a single, manually-created COD row — nested `customer`
    // relation) and the already-grouped record built by index() (used by deliveryInvoices.vue's
    // own view action — flat customer_name/phone_number/customer_credit fields, no city/
    // governorate data). Normalize both into one shape so the template only reads this.
    resolvedCustomer() {
      const c = this.invoiceData.customer
      if (c) {
        return {
          full_name: c.full_name || '',
          phone_number: c.phone_number || '',
          phone_number_2: c.phone_number_2 || '',
          credit: Number(c.credit || 0),
          address: c.city && c.city.governorate
            ? (c.city.governorate.governorate_name + ' - ' + c.city.city_name + ' - ' + c.address)
            : (c.address || ''),
          selected_address: c.selected_address || null
        }
      }
      return {
        full_name: this.invoiceData.customer_name || '',
        phone_number: this.invoiceData.phone_number || '',
        phone_number_2: this.invoiceData.phone_number_2 || '',
        credit: Number(this.invoiceData.customer_credit || 0),
        address: '',
        selected_address: null
      }
    },

    // Same two-shape situation as resolvedCustomer() — show()'s single `order_invoice` relation
    // vs. index()'s already-grouped `invoices` array (one entry per attached shipping invoice).
    invoicesList() {
      if (Array.isArray(this.invoiceData.invoices)) {
        return this.invoiceData.invoices.map((inv) => ({
          order_invoice_id: inv.order_invoice_id_fk,
          invoice_number: inv.order_invoice_number,
          payment_status: inv.order_invoice_payment_status,
          paid_amount: inv.order_invoice_paid_amount,
          remaining_amount: inv.order_invoice_remaining_amount,
          total_price: inv.order_invoice_total_price,
          edit_count: inv.order_invoice_edit_count,
          orders: inv.orders || []
        })).filter((inv) => inv.invoice_number)
      }
      if (this.invoiceData.order_invoice) {
        const inv = this.invoiceData.order_invoice
        return [{
          order_invoice_id: inv.order_invoice_id,
          invoice_number: inv.invoice_number,
          payment_status: inv.payment_status,
          paid_amount: inv.paid_amount,
          remaining_amount: inv.remaining_amount,
          total_price: this.invoiceTotalUsd(inv),
          edit_count: inv.edit_count,
          orders: this.invoiceData.orders || []
        }]
      }
      return []
    },

    // Detaching only makes sense for an auto-generated ledger record tied to an OrderDelivery —
    // a manual COD row has no order delivery link and was never "attached" to anything in the
    // first place. index()'s grouped shape exposes this as order_delivery_id; show()'s raw model
    // dump (used by branchDeliveredOrder.vue) uses the real column name order_delivery_id_fk.
    orderDeliveryId() {
      return this.invoiceData.order_delivery_id || this.invoiceData.order_delivery_id_fk || null
    },
    canDetach() {
      return !!this.orderDeliveryId && this.$_has_perm('detach_order_delivery_invoice')
    },

    firstOrder() {
      return this.invoiceData && this.invoiceData.orders && this.invoiceData.orders.length > 0
        ? this.invoiceData.orders[0]
        : null
    },
    deliveryMethod() {
      if (!this.firstOrder) return 'default'
      if (this.firstOrder.delivery_confirmed && this.firstOrder.delivery_type === 'office delivery') {
        return 'pickup'
      }
      if (this.firstOrder.delivery_type === 'home delivery') {
        return 'home'
      }
      return 'default'
    },
    deliveryAddressText() {
      const order = this.firstOrder
      if (!order || !order.delivery_address) return ''
      const addr = order.delivery_address
      const parts = [addr.label, addr.area, addr.street, addr.building_name, addr.additional_directions].filter(Boolean)
      return parts.length > 0 ? parts.join(', ') : (addr.name || '')
    },

    // Customer's currently selected default mobile delivery location — same formatting as
    // deliveryAddressText()/orderDeliveryInvoice.vue's defaultAddressText. Shown ahead of the
    // plain profile (governorate/city/address) fallback when neither pickup nor a per-order
    // delivery address applies.
    defaultLocationText() {
      const addr = this.resolvedCustomer.selected_address
      if (!addr) return ''
      const parts = [addr.label, addr.area, addr.street, addr.building_name, addr.additional_directions].filter(Boolean)
      return parts.length > 0 ? parts.join(', ') : (addr.name || '')
    },

    // Amount still owed across every attached shipping invoice (0 for paid/canceled,
    // remaining_amount for partial_paid, full amount for not_paid) — mirrors
    // orderDeliveryInvoice.vue's totalUsd. index()'s grouped row already sums this
    // server-side (invoiceData.total_price); show()'s single-invoice shape attaches
    // amount_owed directly onto order_invoice instead.
    totalUsd() {
      if (this.invoiceData.total_price !== undefined && this.invoiceData.total_price !== null) {
        return Number(this.invoiceData.total_price).toFixed(2)
      }
      const invoice = this.invoiceData.order_invoice
      return invoice ? Number(invoice.amount_owed || 0).toFixed(2) : '0.00'
    },
    totalIqdRaw() {
      const raw = Number(this.totalUsd) * Number(this.exRate)
      return roundUpIqd(raw)
    },
    totalIqd() {
      return this.totalIqdRaw.toLocaleString()
    },
    // IRAQI DINAR (shipping invoice total) + Pay On Delivery, both in IQD.
    grandTotalIqd() {
      const payOnDeliveryIqd = this.formatIQD(this.invoiceData.pay_on_delivery_iqd)
      return (this.totalIqdRaw + payOnDeliveryIqd).toLocaleString()
    }
  },

  methods: {
    formatIQD(value) {
      return Math.round(Number(value) || 0)
    },

    invoiceTotalUsd(invoice) {
      const val = Number(invoice.discount) > 0 ? invoice.net_price : invoice.total_price
      return Number(val || 0)
    },

    // Same two calculations as orderDeliveryInvoice.vue's/OrderInvoiceDocument.vue's Items
    // Table, so the per-order detail row here matches exactly.
    /** Per-unit USD: item_price + internal_shipping_handling (int. ship. hidden from its own row). */
    orderUnitPriceCombined(order) {
      return Number(order.item_price || 0) + Number(order.internal_shipping_handling || 0)
    },
    // The order's own total_amount is the actual charged amount — NOT unit price × quantity.
    orderLineTotalCombined(order) {
      return Number(order.total_amount || 0)
    },

    // Same badge colors as orderDeliveryInvoice.vue's/orderInvoices.vue's paymentStatusColor().
    paymentStatusColor(status, editCount) {
      if (status === 'not_paid' && !Number(editCount)) {
        return { bg: '#E0E0E0', color: '#616161' }
      }

      const map = {
        not_paid: { bg: '#F63049', color: '#FFFFFF' },
        partial_paid: { bg: '#FFC85C', color: '#6B4C00' },
        paid: { bg: '#89D7B7', color: '#1A5940' },
        cancel: { bg: '#FB8C00', color: '#FFFFFF' }
      }
      return map[status] || { bg: '#F5F5F5', color: '#616161' }
    },

    paymentStatusLabel(status) {
      const map = {
        not_paid: this.$t('invoice.unpaidStatus'),
        partial_paid: this.$t('invoice.partialPaidStatus'),
        paid: this.$t('invoice.paidStatus'),
        cancel: this.$t('invoice.cancelStatus')
      }
      return map[status] || (status ? status.replace(/_/g, ' ') : '')
    },

    // Same detach flow as orderDeliveryInvoice.vue's detachInvoice() — same endpoint, same
    // confirm copy — since this view's Actions column is only shown for a grouped, auto-created
    // ledger record (canDetach), which is exactly what that endpoint operates on.
    detachInvoice(invoice) {
      swal({
        title: this.$t('delivery.detachConfirmTitle'),
        text: this.$t('delivery.detachConfirmText', { invoice: invoice.invoice_number }),
        icon: 'warning',
        buttons: true,
        dangerMode: true
      }).then((confirmed) => {
        if (!confirmed) return

        const token = localStorage.getItem('access_token')
        axios
          .post('api/order-delivery/detach-invoice', {
            order_delivery_id: this.orderDeliveryId,
            order_invoice_id: invoice.order_invoice_id
          }, { headers: { Authorization: 'Bearer ' + token } })
          .then((response) => {
            this.$emit('detached')
            swal({ text: response.data.message, icon: 'success', timer: 1500, buttons: false })
          })
          .catch((err) => {
            const msg = (err.response && err.response.data && err.response.data.message)
              ? err.response.data.message
              : this.$t('invoice.somethingWentWrong')
            swal({ text: msg, icon: 'error' })
          })
      })
    },

    printInvoice() {
      // Log the print event (fire-and-forget)
      try {
        const token = localStorage.getItem('access_token')
        const credit = this.resolvedCustomer.credit < 0 ? Math.abs(this.resolvedCustomer.credit) : 0
        axios.post('api/print-logs', {
          invoice_number: this.invoiceData.invoice_number,
          invoice_type: 'delivery',
          customer_name: this.resolvedCustomer.full_name,
          total_amount: credit
        }, { headers: { Authorization: 'Bearer ' + token } }).catch(() => {})
      } catch (e) { /* silent */ }

      $('#close-button').hide()
      $('#print-button').hide()
      $('.no-print').hide()
      $('.show-in-print').show()

      $('#print-area').printMe({ path: this.$_print_stylesheet_paths() })

      $('#close-button').show()
      $('#print-button').show()
      $('.no-print').show()
      $('.show-in-print').hide()
    }
  }
}
</script>

<style>
#print-area {
  max-width: 850px;
}

/* Keeps wide tables from forcing the whole page/viewport wider than the phone screen on
   mobile — without this, a table with more columns than fit a phone's width stretches its
   ancestors, so the browser renders (and prints) the entire page at a larger effective size
   than the device, which looks like being "zoomed in" and can't be fixed by pinch-zooming
   out (that only shrinks everything uniformly, it doesn't reflow the layout narrower). Only
   the table itself scrolls horizontally within its own box; the rest of the page stays sized
   to the viewport. Printing still needs the full table, not just the visible scrolled slice,
   so overflow is reset to visible under @media print. */
.print-scroll-x {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}
@media print {
  .print-scroll-x {
    overflow: visible !important;
  }
}

.modal {
  text-align: center;
  padding: 0 !important;
}

.modal:before {
  content: '';
  display: inline-block;
  height: 100%;
  vertical-align: middle;
  margin-right: -4px;
}

.modal-dialog {
  display: inline-block;
  text-align: left;
  vertical-align: middle;
}

@media screen and (max-width: 650px) {
  #credit-table-header {
    width: 500px;
    padding-left: 10px;
  }
  #price-section2 {
    width: 500px;
    padding-left: 10px;
    padding-top: 10px;
    font-size: 15px;
  }
  #price-section {
    width: 280px;
  }
  #company-info {
    width: 100%;
  }
  #header-img {
    width: 60px;
    height: 60px;
  }
  #print-area {
    max-width: 100%;
  }

  /* Vuetify's own dialog (unlike Bootstrap's .modal:before/.modal-dialog hack used by
     orderDeliveryInvoice.vue) already caps itself to max-height: 90% and scrolls its own
     content, so it doesn't have that hack's "dead space before the top" bug. But at 90%
     height plus a 24px margin all around, a phone screen wastes a lot of its already-small
     area on margin instead of content, forcing more scrolling than necessary. Below this
     breakpoint, let the dialog use the full screen (edge-to-edge, no cap) so more of the
     invoice fits before any scrolling is needed — content-class="delivery-invoice-view-dialog"
     on the v-dialog (see template) puts this class on the actual .dialog element. */
  .delivery-invoice-view-dialog.dialog {
    margin: 0 !important;
    max-height: 100% !important;
    min-height: 100%;
    border-radius: 0 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/deliveryInvoice/ViewCustomerDeliveryInvoice.vue